import { Text, View, Image } from "@react-pdf/renderer";
import { styles } from "./ReactPdfStyles";
import QRCode from "../../assets/image/qr_img.png";

type PersonalDetailSectionTypes = {
	name: string;
	email: string;
	phone?: string;
	period: string;
	total_projects: number;
};

function PersonalDetailSection({ data }: { data: PersonalDetailSectionTypes }) {
	console.log("PersonalDetailSection data", data);
	return (
		<View style={[styles.section, styles.tableFontSize]}>
			<Text style={styles.tableHeader}>Project Detail</Text>

			<View style={styles.row}>
				<View style={{ width: "80%", flexDirection: "column" }}>
					<View style={styles.row}>
						<Text style={styles.labelCell}>Name</Text>
						<Text style={styles.valueCell}>{data.name}</Text>
						<Text style={styles.labelCell}>Phone</Text>
						<Text style={styles.valueCell}>{data.phone || "-"}</Text>
					</View>

					<View style={styles.row}>
						<View style={{ flex: 2 }}>
							<View style={styles.row}>
								<Text style={styles.labelCell}>Email</Text>
								<Text style={styles.valueCell}>{data.email}</Text>
							</View>
							<View style={styles.row}>
								<Text style={styles.labelCell}>Period</Text>
								<Text style={styles.valueCell}>{data.period}</Text>
							</View>
						</View>

						<View style={[styles.row, { flex: 2 }]}>
							<Text style={styles.labelCell}>No. of projects(s) involved</Text>
							<Text style={styles.valueCell}>{data.total_projects}</Text>
						</View>
					</View>
				</View>

				<View style={styles.qrContainer}>
					<Image src={QRCode} style={styles.QRSize} />
					<Text style={{ fontSize: 8 }}>Scan/Click here to review data</Text>
				</View>
			</View>
		</View>
	);
}

export default PersonalDetailSection;
